import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { axiosInstance } from '../../../api/axios-instance';
import { AsyncThunkFunctionModel } from '../../../models/async-thunk-function.model';
import { ItemLabelModel } from '../models/dropdown-props.model';

export const getDropdownData = <Entity, ItemLabelModelType>(
  mapper: (data: Entity) => ItemLabelModel<ItemLabelModelType>
): AsyncThunkFunctionModel<ItemLabelModel<ItemLabelModelType>[], string> =>
  createAsyncThunk('dropdown/getDropdownData', async (endpoint: string) => {
    const { data }: AxiosResponse<Entity[]> = await axiosInstance.get(endpoint);
    return data.map(mapper);
  });
